import * as React from 'react';
import * as styles from './styles.css';

import { Header1, InlineText1 } from '@cian/ui-kit/typography';
import { Trend } from '../../../Trend';
import { IStripItem } from '../../../../types/hero';

export type TStripItemProps = IStripItem;

export function StripItem({ trend, title, description }: TStripItemProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['top-line']}>
        <div className={styles['trend']}>
          <Trend trend={trend} />
        </div>
        <div>
          <Header1>{title}</Header1>
        </div>
      </div>
      <InlineText1 color="black_60">{description}</InlineText1>
    </div>
  );
}
